import { useEffect, useState } from "react";
import api from "@/lib/api";
import { HERO_SLIDES, PACKAGES, VISA_SERVICES, TESTIMONIALS, COUNTERS, BLOG_POSTS, FAQS, OFFICES, PHONES } from "@/lib/siteData";

const FALLBACKS = {
  stats: COUNTERS,
  hero_slides: HERO_SLIDES,
  packages: PACKAGES,
  visa_services: VISA_SERVICES,
  testimonials: TESTIMONIALS,
  blogs: BLOG_POSTS,
  faqs: FAQS,
  offices: OFFICES,
  phones: PHONES,
  uae_visa_types: [],
  legal: [],
  client_gallery: [],
  visa_approvals: [],
  google_reviews: { rating: 4.9, count: 120, link: "#" },
  flight_promos: [],
};

let cache = null;
let promise = null;
const listeners = new Set();

function load() {
  if (!promise) {
    promise = api.get("/public/content")
      .then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); return cache; })
      .catch(() => { cache = {}; return cache; });
  }
  return promise;
}

export function useContent(key) {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    if (!cache) {
      const fn = (c) => setContent({ ...c });
      listeners.add(fn);
      load();
      return () => listeners.delete(fn);
    }
  }, []);
  const val = content && content[key] != null ? content[key] : FALLBACKS[key];
  return val;
}
